
const data = {
 STATUSLIST: [
  { name: '全部', id: -1 },
  { name: '待审批', id: 2 },
  { name: '待保障', id: 3 },
  { name: '已通过', id: 5 },
  { name: '已驳回', id: 4 },
  { name: '已失效', id: 6 },
 ]
}

export default data


// WEBPACK FOOTER //
// ./src/utils/Mapping.js